// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lockout-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: radial-gradient(circle at center, #111827 0%, #030712 100%);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  color: #f3f4f6;
  padding: 20px;
  box-sizing: border-box;
}

.lockout-card {
  background: rgba(17, 24, 39, 0.7);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 24px;
  padding: 48px;
  max-width: 480px;
  width: 100%;
  text-align: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5), 
              0 0 40px rgba(99, 102, 241, 0.1);
  animation: fadeInLock 0.6s ease-out;
}

@keyframes fadeInLock {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.lockout-icon {
  font-size: 64px;
  margin-bottom: 24px;
  animation: floatIcon 4s ease-in-out infinite;
}

@keyframes floatIcon {
  0%, 100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(5deg);
  }
}

.lockout-card h1 {
  font-size: 28px;
  font-weight: 700;
  margin-bottom: 12px;
  background: linear-gradient(135deg, #ffffff 0%, #cbd5e1 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  letter-spacing: -0.5px;
}

.lockout-message {
  font-size: 15px;
  color: #9ca3af;
  line-height: 1.6;
  margin-bottom: 32px;
}

.lockout-hours {
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 32px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  text-align: left;
}

.lockout-hours > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
}

.lockout-hours span {
  color: #9ca3af;
}

.lockout-hours strong {
  color: #38bdf8;
  font-family: monospace;
  font-size: 15px;
}

.lockout-badge {
  display: inline-block;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.2);
  color: #ef4444;
  padding: 6px 16px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin-bottom: 24px;
}

.lockout-footer {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/components/HorarioGuard.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,uEAAuE;EACvE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,uFAAuF;EACvF,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB;8CAC4C;EAC5C,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE;IACE,qCAAqC;EACvC;EACA;IACE,yCAAyC;EAC3C;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,6DAA6D;EAC7D,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".lockout-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: radial-gradient(circle at center, #111827 0%, #030712 100%);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 99999;\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  color: #f3f4f6;\n  padding: 20px;\n  box-sizing: border-box;\n}\n\n.lockout-card {\n  background: rgba(17, 24, 39, 0.7);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 24px;\n  padding: 48px;\n  max-width: 480px;\n  width: 100%;\n  text-align: center;\n  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5), \n              0 0 40px rgba(99, 102, 241, 0.1);\n  animation: fadeInLock 0.6s ease-out;\n}\n\n@keyframes fadeInLock {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.lockout-icon {\n  font-size: 64px;\n  margin-bottom: 24px;\n  animation: floatIcon 4s ease-in-out infinite;\n}\n\n@keyframes floatIcon {\n  0%, 100% {\n    transform: translateY(0) rotate(0deg);\n  }\n  50% {\n    transform: translateY(-10px) rotate(5deg);\n  }\n}\n\n.lockout-card h1 {\n  font-size: 28px;\n  font-weight: 700;\n  margin-bottom: 12px;\n  background: linear-gradient(135deg, #ffffff 0%, #cbd5e1 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  letter-spacing: -0.5px;\n}\n\n.lockout-message {\n  font-size: 15px;\n  color: #9ca3af;\n  line-height: 1.6;\n  margin-bottom: 32px;\n}\n\n.lockout-hours {\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  border-radius: 16px;\n  padding: 20px;\n  margin-bottom: 32px;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  text-align: left;\n}\n\n.lockout-hours > div {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 14px;\n}\n\n.lockout-hours span {\n  color: #9ca3af;\n}\n\n.lockout-hours strong {\n  color: #38bdf8;\n  font-family: monospace;\n  font-size: 15px;\n}\n\n.lockout-badge {\n  display: inline-block;\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid rgba(239, 68, 68, 0.2);\n  color: #ef4444;\n  padding: 6px 16px;\n  border-radius: 9999px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  margin-bottom: 24px;\n}\n\n.lockout-footer {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
